import { FC } from 'react';
import { Trans } from 'react-i18next';

import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface SubmissionsTableEmptyRowProps {
  className?: string;
}

export const SubmissionsTableEmptyRow: FC<SubmissionsTableEmptyRowProps> = ({
  className,
}: SubmissionsTableEmptyRowProps) => (
  <TableRow className={cn('hover:bg-transparent', className)}>
    <TableCell
      colSpan={4}
      className='text-muted-foreground bg-white text-center text-sm whitespace-normal'>
      <Trans i18nKey='common.empty' />
    </TableCell>
  </TableRow>
);
